/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { DiscountDuration$inboundSchema, DiscountDuration$outboundSchema, } from "./discountduration.js";
import { DiscountType$inboundSchema, DiscountType$outboundSchema, } from "./discounttype.js";
/** @internal */
export const DiscountPercentageOnceForeverDurationBaseMetadata$inboundSchema = z
    .union([z.string(), z.int(), z.number(), z.boolean()]);
/** @internal */
export const DiscountPercentageOnceForeverDurationBaseMetadata$outboundSchema = z.union([z.string(), z.int(), z.number(), z.boolean()]);
export function discountPercentageOnceForeverDurationBaseMetadataToJSON(discountPercentageOnceForeverDurationBaseMetadata) {
    return JSON.stringify(DiscountPercentageOnceForeverDurationBaseMetadata$outboundSchema.parse(discountPercentageOnceForeverDurationBaseMetadata));
}
export function discountPercentageOnceForeverDurationBaseMetadataFromJSON(jsonString) {
    return safeParse(jsonString, (x) => DiscountPercentageOnceForeverDurationBaseMetadata$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'DiscountPercentageOnceForeverDurationBaseMetadata' from JSON`);
}
/** @internal */
export const DiscountPercentageOnceForeverDurationBase$inboundSchema = z.pipe(z.object({
    duration: DiscountDuration$inboundSchema,
    type: DiscountType$inboundSchema,
    basis_points: z.int(),
    created_at: z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    modified_at: z.nullable(z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v)))),
    id: z.string(),
    metadata: z.record(z.string(), z.union([z.string(), z.int(), z.number(), z.boolean()])),
    name: z.string(),
    code: z.nullable(z.string()),
    starts_at: z.nullable(z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v)))),
    ends_at: z.nullable(z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v)))),
    max_redemptions: z.nullable(z.int()),
    redemptions_count: z.int(),
    organization_id: z.string(),
}), z.transform((v) => {
    return remap$(v, {
        "basis_points": "basisPoints",
        "created_at": "createdAt",
        "modified_at": "modifiedAt",
        "starts_at": "startsAt",
        "ends_at": "endsAt",
        "max_redemptions": "maxRedemptions",
        "redemptions_count": "redemptionsCount",
        "organization_id": "organizationId",
    });
}));
/** @internal */
export const DiscountPercentageOnceForeverDurationBase$outboundSchema = z.pipe(z.object({
    duration: DiscountDuration$outboundSchema,
    type: DiscountType$outboundSchema,
    basisPoints: z.int(),
    createdAt: z.pipe(z.date(), z.transform(v => v.toISOString())),
    modifiedAt: z.nullable(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    id: z.string(),
    metadata: z.record(z.string(), z.union([z.string(), z.int(), z.number(), z.boolean()])),
    name: z.string(),
    code: z.nullable(z.string()),
    startsAt: z.nullable(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    endsAt: z.nullable(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    maxRedemptions: z.nullable(z.int()),
    redemptionsCount: z.int(),
    organizationId: z.string(),
}), z.transform((v) => {
    return remap$(v, {
        basisPoints: "basis_points",
        createdAt: "created_at",
        modifiedAt: "modified_at",
        startsAt: "starts_at",
        endsAt: "ends_at",
        maxRedemptions: "max_redemptions",
        redemptionsCount: "redemptions_count",
        organizationId: "organization_id",
    });
}));
export function discountPercentageOnceForeverDurationBaseToJSON(discountPercentageOnceForeverDurationBase) {
    return JSON.stringify(DiscountPercentageOnceForeverDurationBase$outboundSchema.parse(discountPercentageOnceForeverDurationBase));
}
export function discountPercentageOnceForeverDurationBaseFromJSON(jsonString) {
    return safeParse(jsonString, (x) => DiscountPercentageOnceForeverDurationBase$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'DiscountPercentageOnceForeverDurationBase' from JSON`);
}
//# sourceMappingURL=discountpercentageonceforeverdurationbase.js.map